import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/Stores/auth-v2-store";
import { Loader2 } from "lucide-react";

/**
 * Garde d'accès de la plateforme upsell — auth v2 : utilisateur INTERNAL
 * porteur de la permission `upsell.access` (la vraie protection est côté API,
 * le PermissionsGuard relit les droits en DB à chaque requête).
 */
export function RequireAuth() {
  const { isAuthReady, isAuthenticated, currentUser, hasPermission, logout } = useAuthStore();
  const location = useLocation();

  // Magic link via hash → transmis à la page de login
  if (location.hash.startsWith("#login_with_access_token=")) {
    const access_token = location.hash.substring("#login_with_access_token=".length);
    return <Navigate to="/login" state={{ from: location, access_token }} replace />
  }

  // Attendre l'hydratation du store
  if (!isAuthReady) {
    return (
      <div className="tw-min-h-screen tw-bg-gray-50 tw-flex tw-items-center tw-justify-center">
        <Loader2 className="tw-w-8 tw-h-8 tw-animate-spin tw-text-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated || !currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Réservé aux internes
  if (currentUser.type !== 'INTERNAL') {
    logout();
    return <Navigate to="/login" state={{ error: "Vous n'avez pas les droits d'accès à cette application." }} replace />;
  }

  // Permission plateforme upsell
  if (!hasPermission('upsell.access')) {
    return (
      <div className="tw-min-h-screen tw-bg-gray-50 tw-flex tw-items-center tw-justify-center tw-px-4">
        <div className="tw-max-w-md tw-w-full tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-8 tw-text-center">
          <div className="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 tw-mb-4">
            <svg className="tw-h-6 tw-w-6 tw-text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
          </div>
          <h1 className="tw-text-xl tw-font-bold tw-text-gray-900 tw-mb-2">Accès non autorisé</h1>
          <p className="tw-text-gray-600 tw-mb-6">
            Votre compte n'a pas la permission d'accéder à la plateforme UpSell.
            Rapprochez-vous d'un administrateur pour obtenir le droit « upsell.access ».
          </p>
          <button
            onClick={() => logout()}
            className="tw-w-full tw-px-4 tw-py-2 tw-bg-gray-200 tw-text-gray-700 tw-font-medium tw-rounded-md hover:tw-bg-gray-300"
          >
            Se déconnecter
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
